import script from "./JoinHouseholdView.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinHouseholdView.vue?vue&type=script&setup=true&lang=js"

import "./JoinHouseholdView.vue?vue&type=style&index=0&id=2d9ffd10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9ffd10"]])

export default __exports__